// components/media/MediaGrid.tsx
import { TooltipProvider } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { MediaAsset } from "@/types/media";
import { MediaCard } from "./MediaCard";

type MediaGridProps = {
  items: MediaAsset[];
  selectable?: boolean;
  selectedIds?: string[];
  onToggleSelect?: (id: string) => void;
  onPreview?: (item: MediaAsset) => void;
  onCopyUrl?: (item: MediaAsset) => void;
  onDelete?: (item: MediaAsset) => void;
  className?: string;
  emptyText?: string;
};

export function MediaGrid({
  items,
  selectable = false,
  selectedIds = [],
  onToggleSelect,
  onPreview,
  onCopyUrl,
  onDelete,
  className,
  emptyText = "No media found.",
}: MediaGridProps) {
  if (!items?.length) {
    return (
      <div
        className={cn(
          "flex h-40 items-center justify-center rounded-md border border-dashed border-slate-200 text-slate-500 text-sm",
          className
        )}
      >
        {emptyText}
      </div>
    );
  }

  return (
    <TooltipProvider>
      <div
        className={cn(
          // 2 cols on xs, 3 on sm, 4 on md, 5 on lg, 6 on xl
          "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2",
          className
        )}
      >
        {items.map((asset) => (
          <MediaCard
            key={asset.id}
            asset={asset}
            selected={selectable && selectedIds.includes(asset.id)}
            onToggleSelect={selectable ? () => onToggleSelect?.(asset.id) : undefined}
            onPreview={onPreview ? () => onPreview(asset) : undefined}
            onCopyUrl={onCopyUrl ? () => onCopyUrl(asset) : undefined}
            onDelete={onDelete ? () => onDelete(asset) : undefined}
          />
        ))}
      </div>
    </TooltipProvider>
  );
}
